import {subirMultiplesImagenHostingFile} from "./subirMultiplesImagenHostingFile";

export const subirImgArrObjetos = async ({arr, propiedad}) => {

    let arrImg = []
    for (let i = 0; i < arr.length; i++) {
        let obj = arr[i]
        let imgBlob = obj[propiedad]
        if (imgBlob) {
            arrImg.push(imgBlob)
        } else {
            arrImg.push('')
        }

    }



    let result = await subirMultiplesImagenHostingFile(arrImg)
    console.log(result)
    if (result.res) {
        let arrUrls = result.data

        let arrRes = []
        for (let i = 0; i < arr.length; i++) {
            let obj = arr[i]
            obj[propiedad] = arrUrls[i]
            arrRes.push(obj)

        }

        return arrRes
    } else {
        return []
    }


}